const localImageURLPattern = /(?:^|[\s("'<=])(?:blob:https?:|data:image\/)/i;

export function hasLocalImageReference(markdown: string): boolean {
  return localImageURLPattern.test(markdown);
}
